/**
 * Countries with dial codes for phone input.
 * Morocco and France first (default order), then others alphabetically by name.
 */

export interface CountryOption {
  code: string;
  dialCode: string;
  name: string;
  nameEn: string;
  flag: string;
}

const allCountries: CountryOption[] = [
  { code: 'MA', dialCode: '212', name: 'Maroc', nameEn: 'Morocco', flag: '🇲🇦' },
  { code: 'FR', dialCode: '33', name: 'France', nameEn: 'France', flag: '🇫🇷' },
  { code: 'DZ', dialCode: '213', name: 'Algérie', nameEn: 'Algeria', flag: '🇩🇿' },
  { code: 'BE', dialCode: '32', name: 'Belgique', nameEn: 'Belgium', flag: '🇧🇪' },
  { code: 'CA', dialCode: '1', name: 'Canada', nameEn: 'Canada', flag: '🇨🇦' },
  { code: 'CN', dialCode: '86', name: 'Chine', nameEn: 'China', flag: '🇨🇳' },
  { code: 'ES', dialCode: '34', name: 'Espagne', nameEn: 'Spain', flag: '🇪🇸' },
  { code: 'DE', dialCode: '49', name: 'Allemagne', nameEn: 'Germany', flag: '🇩🇪' },
  { code: 'IT', dialCode: '39', name: 'Italie', nameEn: 'Italy', flag: '🇮🇹' },
  { code: 'NL', dialCode: '31', name: 'Pays-Bas', nameEn: 'Netherlands', flag: '🇳🇱' },
  { code: 'GB', dialCode: '44', name: 'Royaume-Uni', nameEn: 'United Kingdom', flag: '🇬🇧' },
  { code: 'US', dialCode: '1', name: 'États-Unis', nameEn: 'United States', flag: '🇺🇸' },
  { code: 'TN', dialCode: '216', name: 'Tunisie', nameEn: 'Tunisia', flag: '🇹🇳' },
  { code: 'EG', dialCode: '20', name: 'Égypte', nameEn: 'Egypt', flag: '🇪🇬' },
  { code: 'SA', dialCode: '966', name: 'Arabie saoudite', nameEn: 'Saudi Arabia', flag: '🇸🇦' },
  { code: 'AE', dialCode: '971', name: 'Émirats arabes unis', nameEn: 'United Arab Emirates', flag: '🇦🇪' },
  { code: 'CH', dialCode: '41', name: 'Suisse', nameEn: 'Switzerland', flag: '🇨🇭' },
  { code: 'LU', dialCode: '352', name: 'Luxembourg', nameEn: 'Luxembourg', flag: '🇱🇺' },
  { code: 'PT', dialCode: '351', name: 'Portugal', nameEn: 'Portugal', flag: '🇵🇹' },
  { code: 'SN', dialCode: '221', name: 'Sénégal', nameEn: 'Senegal', flag: '🇸🇳' },
  { code: 'CI', dialCode: '225', name: "Côte d'Ivoire", nameEn: "Côte d'Ivoire", flag: '🇨🇮' },
  { code: 'CM', dialCode: '237', name: 'Cameroun', nameEn: 'Cameroon', flag: '🇨🇲' },
  { code: 'ML', dialCode: '223', name: 'Mali', nameEn: 'Mali', flag: '🇲🇱' },
  { code: 'BF', dialCode: '226', name: 'Burkina Faso', nameEn: 'Burkina Faso', flag: '🇧🇫' },
  { code: 'NE', dialCode: '227', name: 'Niger', nameEn: 'Niger', flag: '🇳🇪' },
  { code: 'TG', dialCode: '228', name: 'Togo', nameEn: 'Togo', flag: '🇹🇬' },
  { code: 'BJ', dialCode: '229', name: 'Bénin', nameEn: 'Benin', flag: '🇧🇯' },
  { code: 'MU', dialCode: '230', name: 'Maurice', nameEn: 'Mauritius', flag: '🇲🇺' },
  { code: 'TR', dialCode: '90', name: 'Turquie', nameEn: 'Turkey', flag: '🇹🇷' },
  { code: 'RU', dialCode: '7', name: 'Russie', nameEn: 'Russia', flag: '🇷🇺' },
  { code: 'IN', dialCode: '91', name: 'Inde', nameEn: 'India', flag: '🇮🇳' },
  { code: 'BR', dialCode: '55', name: 'Brésil', nameEn: 'Brazil', flag: '🇧🇷' },
  { code: 'JP', dialCode: '81', name: 'Japon', nameEn: 'Japan', flag: '🇯🇵' },
  { code: 'AU', dialCode: '61', name: 'Australie', nameEn: 'Australia', flag: '🇦🇺' },
  { code: 'MX', dialCode: '52', name: 'Mexique', nameEn: 'Mexico', flag: '🇲🇽' },
  { code: 'PL', dialCode: '48', name: 'Pologne', nameEn: 'Poland', flag: '🇵🇱' },
  { code: 'SE', dialCode: '46', name: 'Suède', nameEn: 'Sweden', flag: '🇸🇪' },
  { code: 'AT', dialCode: '43', name: 'Autriche', nameEn: 'Austria', flag: '🇦🇹' },
  { code: 'GR', dialCode: '30', name: 'Grèce', nameEn: 'Greece', flag: '🇬🇷' },
  { code: 'ZA', dialCode: '27', name: 'Afrique du Sud', nameEn: 'South Africa', flag: '🇿🇦' },
  { code: 'NG', dialCode: '234', name: 'Nigeria', nameEn: 'Nigeria', flag: '🇳🇬' },
  { code: 'KE', dialCode: '254', name: 'Kenya', nameEn: 'Kenya', flag: '🇰🇪' },
  { code: 'GH', dialCode: '233', name: 'Ghana', nameEn: 'Ghana', flag: '🇬🇭' },
  { code: 'QA', dialCode: '974', name: 'Qatar', nameEn: 'Qatar', flag: '🇶🇦' },
  { code: 'KW', dialCode: '965', name: 'Koweït', nameEn: 'Kuwait', flag: '🇰🇼' },
  { code: 'BH', dialCode: '973', name: 'Bahreïn', nameEn: 'Bahrain', flag: '🇧🇭' },
  { code: 'OM', dialCode: '968', name: 'Oman', nameEn: 'Oman', flag: '🇴🇲' },
  { code: 'JO', dialCode: '962', name: 'Jordanie', nameEn: 'Jordan', flag: '🇯🇴' },
  { code: 'LB', dialCode: '961', name: 'Liban', nameEn: 'Lebanon', flag: '🇱🇧' },
  { code: 'PK', dialCode: '92', name: 'Pakistan', nameEn: 'Pakistan', flag: '🇵🇰' },
  { code: 'BD', dialCode: '880', name: 'Bangladesh', nameEn: 'Bangladesh', flag: '🇧🇩' },
  { code: 'ID', dialCode: '62', name: 'Indonésie', nameEn: 'Indonesia', flag: '🇮🇩' },
  { code: 'MY', dialCode: '60', name: 'Malaisie', nameEn: 'Malaysia', flag: '🇲🇾' },
  { code: 'SG', dialCode: '65', name: 'Singapour', nameEn: 'Singapore', flag: '🇸🇬' },
  { code: 'AR', dialCode: '54', name: 'Argentine', nameEn: 'Argentina', flag: '🇦🇷' },
  { code: 'CL', dialCode: '56', name: 'Chili', nameEn: 'Chile', flag: '🇨🇱' },
  { code: 'CO', dialCode: '57', name: 'Colombie', nameEn: 'Colombia', flag: '🇨🇴' },
  { code: 'PE', dialCode: '51', name: 'Pérou', nameEn: 'Peru', flag: '🇵🇪' },
];

/** Morocco first, France second, then rest by name (French) */
export const countriesByDefault: CountryOption[] = [
  allCountries[0], // MA
  allCountries[1], // FR
  ...allCountries.slice(2).sort((a, b) => a.name.localeCompare(b.name)),
];

/** Find country by dial code (longest match first) */
export function getCountryByDialCode(phoneDigits: string): CountryOption | null {
  if (!phoneDigits) return null;
  const sorted = [...allCountries].sort((a, b) => b.dialCode.length - a.dialCode.length);
  for (const c of sorted) {
    if (phoneDigits.startsWith(c.dialCode)) return c;
  }
  return null;
}

/** Parse full E.164 digits into country + national number */
export function parseE164(phoneDigits: string): { country: CountryOption; national: string } | null {
  const country = getCountryByDialCode(phoneDigits);
  if (!country) return null;
  const national = phoneDigits.slice(country.dialCode.length).replace(/^0+/, '') || '';
  return { country, national };
}

export default countriesByDefault;
